import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

import FrontPage from './FrontPage';
import SearchPage from './SearchPage/SearchPage';

import { Route, BrowserRouter } from 'react-router-dom';
import ReactGA from "react-ga";

const ENDPOINT = 'https://invidia.herokuapp.com/search';
//const ENDPOINT = 'https://invidia-backend.ian.pw/search';

ReactGA.initialize("UA-107735490-1");

// Listen for changes to the current location.
function logPageView() {
  ReactGA.set({ page: window.location.pathname + window.location.search });
  ReactGA.pageview(window.location.pathname + window.location.search);
}


const HomePageWrapped = (props) => {
  return <FrontPage endpoint={ENDPOINT} {...props} />;
}

const SearchPageWrapped = (props) => {
  const params = new URLSearchParams(props.location.search);
  return <SearchPage endpoint={ENDPOINT} query={params.get('q')} />;
}

class App extends Component {
  render() {
    return (
      <div className="reactRoot">
        <Route path="/" component={HomePageWrapped} exact={true} />
        <Route path="/search" component={SearchPageWrapped} />
      </div>
    );
  }
}

export default () => {
  return (
    <BrowserRouter basename='/videosearch' onUpdate={logPageView}>
      <App />
    </BrowserRouter>
  );
};



// WEBPACK FOOTER //
// ./src/App.js